enum ConsoleApi {
  APPROVAL_LIST = "admin/registration/findRegistrationParticipantListByRegistration",
  APPROVAL_LIST_DETAIL_BY_ID = "admin/registration/listDetail/findRegistrationParticipantById",
  FIND_REGISTRATION_PARTICIPANT_BY_ID = "admin/registration/findRegistrationParticipant",
  FIND_REGISTRATION_FORM_BY_REGISTRATION_FORM_ID = "admin/registration/findRegistrationForm",
  UPDATE_REGISTRAION_PROFILE = "admin/registration/updateProfile",
  UPDATE_REGISTRAION_STATUS = "admin/registration/updateStatus",
  RATE_CARD_FOR_APPROVAL_FLOW = "admin/rateCard/findForApplicationFlow",
  FORM_FOR_PARTICIPANT_AND_ORGANIZATION = `admin/registration/findRegistrationProfileByParticipantAndOrganization`,
  GET_RESUME_URL_FOR_PARTICIPANT = "admin/registrationParticipant/getResumeUrl",
  GET_RESUME_URL_FOR_INVOICE_PAYER = "admin/invoicePaymentRequest/resumeInvoicePaymentRequestUrl",
  REGISTRATION_LIST = "admin/registration/findByEventSeriesId",
  REGISTRATION_DETAILS_LIST = "registration/findByEventSeriesWithEventsAndPrograms",
  CREATE_REGISTRATION = "admin/registration/create",
  UPDATE_REGISTRATION = "admin/registration/update",
  CHANGE_REGISTRATION_STATE = "admin/registration/moveState",
  FIND_PARTICIPANT_TYPES_BY_REG_ID = "admin/participantType/findByRegistrationId",
  FIND_PARTICIPANT_TYPE_BY_ID = "admin/participantType/findById",
  UPDATE_PARTICIPANT_TYPE = "admin/participantType/update",
  CREATE_PARTICIPANT_TYPE = "admin/participantType/create",
  RATE_CARD_LIST = "admin/rateCard/findByRegistrationId",
  RATE_CARD_CREATE = "admin/rateCard/create",
  RATE_CARD_UPDATE = "admin/rateCard/update",
  RATE_CARD_DELETE = "admin/rateCard/delete",
  RATE_CARD_COUPON_CODE_DELETE = "admin/rateCardDiscount/delete",
  RATE_CARD_COUPON_CODE_CREATE = "admin/rateCardDiscount/create",
  RATE_CARD_COUPON_CODE_UPDATE = "admin/rateCardDiscount/update",
  GET_RATE_CARD_DETAILS = "admin/rateCard/findById",
  UPDATE_SCHEMA_FIELD = "admin/schemaField/update",
  UPDATE_PLATFORM_FIELD = "admin/schemaField/platform/update",
  GET_SCHEMA_FIELD_BY_ID = "admin/schemaField/findById",
  GET_SCHEMA_FIELDS_BY_REG_ID = "admin/schemaField/findByRegistrationId",
  CREATE_SCHEMA_FIELD = "admin/schemaField/create",
  DELETE_SCHEMA_FIELD = "admin/schemaField/delete",
  GET_EVENT_BY_REG_ID = "admin/event/findByRegistrationId",
  GET_EVENT_BY_ID = "admin/event/{eventId}",
  UPDATE_EVENT = "admin/event/update",
  CREATE_EVENT = "admin/event/create",
  GET_CLIENT_DETAILS = "admin/client/{id}",
  GET_CLIENTS_LIST = "platform/client/findAll",
  GET_CLIENT_DETAILS_LIST = "platform/client/findAllWithEventSeriesAndRegistrations",
  GET_EVENT_SERIES_LIST = "platform/eventSeries/findAll",
  GET_EVENT_SERIES_DETAILS_LIST = "platform/eventSeries/findByClientIdWithRegistrations",
  GET_EVENT_SERIES_LIST_BY_USER = "eventSeries/findByConsoleUserId",
  GET_EVENT_SERIES_DETAILS_LIST_BY_USER = "eventSeries/findByConsoleUserIdWithRegistrations",
  PAYMENT_CONFIG_LIST = "admin/paymentConfig/findByRegistrationId",
  PAYMENT_CONFIG_FIND_BY_ID = "admin/paymentConfig/findById",
  PAYMENT_CONFIG_CREATE = "admin/paymentConfig/create",
  PAYMENT_CONFIG_UPDATE = "admin/paymentConfig/update",
  PAYMENT_CONFIG_LOCK = "admin/paymentConfig/lockUnlock",
  PAYMENT_CONFIG_ENABLE = "admin/paymentConfig/enable",
  CONSOLE_USER_LIST = "platform/consoleUser/findAll",
  CONSOLE_USER_DETAIL = "platform/consoleUser/{consoleUserId}",
  CONSOLE_USER_DETAIL_FOR_CLIENT_USER = "consoleUser/{consoleUserId}",
  CONSOLE_USER_FIND_BY_EMAIL = "platform/consoleUser/findByWorkEmail",
  CONSOLE_USER_FIND_BY_EMAIL_FOR_CLIENT_USER = "consoleUser/findByWorkEmail",
  CONSOLE_USER_CREATE = "platform/consoleUser/create",
  CONSOLE_USER_UPDATE = "platform/consoleUser/update",
  CONSOLE_USER_DELETE = "platform/consoleUser/delete",
  CONSOLE_USER_CREATE_FOR_CLIENT_USER = "consoleUser/create",
  CONSOLE_USER_UPDATE_FOR_CLIENT_USER = "consoleUser/update",
  CONSOLE_USER_ADD_ROLE_FOR_CLIENT_USER = "consoleUserRole/create",
  CONSOLE_USER_DELETE_FOR_CLIENT_USER = "consoleUserRole/delete",
  EVENT_SERIES_LIST = "platform/eventSeries/findAll",
  UPDATE_CONSOLE_USER_STATUS = "platform/consoleUser/updateStatus",
  UPDATE_CONSOLE_USER_STATUS_FOR_CLIENT_USER = "consoleUser/updateStatus",
  EVENT_SERIES_LIST_BY_USER_ID = "eventSeries/findByClientUserId/{consoleUserId}",
  FIND_ALL_ROLE = "platform/role/findAll",
  GET_CONSOLE_USER_BY_CONTEXT = "consoleUser/findByContextId/{contextId}",
  GET_ROLE_FOR_CLIENT_USER = "role/findForClientUser",
  GET_EVENT_SERIES = "platform/eventSeries/findAll",
  GET_EVENT_SERIES_BY_ID = "eventSeries/{id}",
  CREATE_EVENT_SERIES = "platform/eventSeries/create",
  UPDATE_EVENT_SERIES = "eventSeries/update",
  CLIENT_LIST = "platform/client/findAll",
  CLIENT_DETAIL = "platform/client/{id}",
  CLIENT_CREATE = "platform/client/create",
  CLIENT_UPDATE = "platform/client/update",
  CLIENT_DELETE = "platform/client/delete/{id}",
  ORG_LIST = "admin/organization/findByEventSeriesId",
  ORG_CREATE = "admin/organization/create",
  ORG_UPDATE = "admin/organization/update",
  ORG_FIND_BY_ID = "admin/organization/findById",
  REGISTRATION_FORM_LIST = "admin/registrationForm/findByRegistrationId",
  REGISTRATION_FORM_CREATE = "admin/registrationForm/create",
  REGISTRATION_FORM_UPDATE = "admin/registrationForm/update",
  REGISTRATION_ACTIVE_INACTIVE_FORM_LIST = "admin/registrationForm/findForDisableAction",
  REGISTRATION_FORMS_INACTIVE = "admin/registrationForm/disable",
  GET_REGISTRATION_FORM_BY_ID = "admin/registrationForm/findById",
  GET_REGISTRATION_FORM_CONFIGURATION_DATA = "admin/registrationForm/configurationData",
  GET_SPONSORING_ORGANIZATIONS_LIST = "admin/registrationOrganization/findSponsoringOrganizationByRegistrationId",
  GET_SPONSORING_ORGANIZATION_FOR_PARTICIPANT = "admin/registrationOrganization/findSponsoringOrganizationByRegistrationParticipantIdAndRegistrationFormId",
  ACCEPT_USER_INVITATION = "protected/consoleUser/accept",
  ACCEPT_USER_ROLE = "consoleUserRole/accept/{consoleUserRoleId}",
  RESET_PASSWORD = "protected/consoleUser/resetPassword",
  CHANGE_PASSWORD = "consoleUser/changePassword",
  FORGOT_PASSWORD = "public/consoleUser/forgotPassword/{workEmail}",
  GET_REGISTRATION_ORGANIZATION_BY_REG_ID = "admin/registrationOrganization/findAllByRegistrationId",
  GET_REGISTRATION_ORGANIZATION_LIST_DETAIL_BY_ID = "admin/registrationOrganization/listDetail/findById",
  GET_REGISTRATION_ORGANIZATION_SCHEMA = "admin/registrationOrganization/findSchemaByRegistrationId",
  GET_REGISTRATION_ORGANIZATION_BY_ID = "admin/registrationOrganization/findById",
  CREATE_REGISTRATION_ORGANIZATION = "admin/registrationOrganization/create",
  UPDATE_REGISTRATION_ORGANIZATION = "admin/registrationOrganization/update",
  FIND_ALL_ATTACHED_REG_FORMS = "admin/registrationOrganization/findAllAttachedToRegForms",
  FIND_APPLICABLE_RPT_TO_REMOVE = "admin/registrationOrganization/findApplicableRPTToRemove",
  FIND_REGISTRATION_FORM_FOR_ASSOCIATION = "admin/registrationForm/findForAssociation",
  GET_PROGRAM_BY_ID = "admin/program/{programId}",
  CREATE_SOCIAL_POST_TEMPLATE = "admin/socialPostTemplate/create",
  UPDATE_SOCIAL_POST_TEMPLATE = "admin/socialPostTemplate/update",
  CREATE_MOBIE_GENERAL_CONFIG = "appConfig/create",
  UPDATE_MOBILE_GENERAL_CONFIG = "appConfig/update",
  CREATE_UPDATE_MOBIE_CHAT_CONFIG = "admin/registration/chatConfiguration/create",
  CREATE_UPDATE_MOBILE_BADGE_CONFIG = "admin/registration/badgeQRCodeConfiguration/create",
  CREATE_PUSH_NOTIFICATION_CONFIG = "appNotificationConfig/create",
  UPDATE_PUSH_NOTIFICATION_CONFIG = "appNotificationConfig/update",
  GET_MOBILE_CONFIGURATIONS_BY_REG_ID = "appConfigConfiguration/findByRegistrationId",
  GET_PUSH_NOTIFICATION_TEMPLATES_BY_REG_ID = "admin/registrationNotificationTemplate/findByRegistrationId",
  GET_PUSH_NOTIFICATION_TEMPLATE_BY_ID = "admin/registrationNotificationTemplate/findById",
  UPDATE_PUSH_NOTIFICATION_TEMPLATE = "admin/registrationNotificationTemplate/update",
  SYNC_PUSH_NOTIFICATION_TEMPLATES = "admin/registrationNotificationTemplate/sync",
  GET_PUSH_NOTIFICATIONS_BY_REG_ID = "admin/adminNotificationTemplate/findByRegistrationId",
  SEND_MOBILE_PUSH_NOTIFICATION = "admin/adminNotificationTemplate/send",
  PREVIEW_MOBILE_PUSH_NOTIFICATION = "admin/registrationNotificationTemplate/preview",
  GET_PUSH_NOTIFICATION_ELIGIBLE_REGISTRATION_FORMS = "admin/registrationForm/broadcastNotification/findByRegistrationId",
  GET_SOCIAL_TEMPLATE_BY_ID = "admin/socialPostTemplate/findById",
  GET_SOCIAL_TEMPLATES_BY_REG_ID = "admin/socialPostTemplate/findByRegistrationId",
  DELETE_SOCIAL_TEMPLATE = "admin/socialPostTemplate/delete",
  CREATE_PARTICIPANT = "admin/registration/initiate",
  CREATE_IN_PERSON_MEETUP_PROGRAM = "admin/program/inPersonMeetup/create",
  CREATE_MEETUP_PROGRAM = "admin/program/meetup/create",
  CREATE_TABLETALK_PROGRAM = "admin/program/tabletalk/create",
  CREATE_BUYERS_PROGRAM = "admin/program/buyersProgram/create",
  CREATE_TRADE_PROGRAM = "admin/program/tradeProgram/create",
  CREATE_CONNECTION_PROGRAM = "admin/program/connectionsProgram/create",
  UPDATE_IN_PERSON_MEETUP_PROGRAM = "admin/program/inPersonMeetup/update",
  UPDATE_MEETUP_PROGRAM = "admin/program/meetup/update",
  UPDATE_TABLETALK_PROGRAM = "admin/program/tabletalk/update",
  UPDATE_BUYERS_PROGRAM = "admin/program/buyersProgram/update",
  UPDATE_TRADE_PROGRAM = "admin/program/tradeProgram/update",
  GET_EMAIL_CONFIG_BY_ID = "admin/emailConfig/findByEntityId",
  UPDATE_EMAIL_CONFIG = "admin/emailConfig/update",
  CREATE_EMAIL_CONFIG = "admin/emailConfig/create",
  GET_EMAIL_CONFIG_BY_ID_PLATFORM_USER = "platform/emailConfig/findByEntityId",
  UPDATE_EMAIL_CONFIG_PLATFORM_USER = "platform/emailConfig/update",
  CREATE_EMAIL_CONFIG_PLATFORM_USER = "platform/emailConfig/create",
  RESEND_CONFIRMATION_NUMBER_EMAIL = "admin/registrationParticipant/resendConfirmationNumber",
  RESEND_RESUME_REGISTRATION_EMAIL = "admin/registrationParticipant/resumeRegistration",
  RESEND_RESUME_REGISTRATION_EMAIL_TO_INVOICE_PAYER = "admin/invoicePaymentRequest/resumeInvoicePaymentRequest",
  GET_CONSOLE_USER_PROFILE = "consoleUser/{consoleUserId}",
  UPDATE_CONSOLE_USER_PROFILE = "consoleUser/updateProfile",
  GET_REGISTRATION_BY_ID = "admin/registration/findById",
  GET_DIVISIONS_FOR_REGISTRATION = "admin/division/findByRegistrationId",
  GET_APPLICABLE_DIVISIONS = "admin/registrationForm/availableDivisions",
  CREATE_DIVISION = "admin/division/create",
  UPDATE_DIVISION = "admin/division/update",
  GET_DIVISION_BY_ID = "admin/division/findById",
  // Platform Email Template related Api
  PLATFORM_EMAIL_TEMPLATE_LIST = "platform/platformEmailTemplate/findAll",
  GET_PLATFORM_EMAIL_TEMPLATE_DETAIL = "platform/platformEmailTemplate/findById",
  PREVIEW_PLATFORM_EMAIL_TEMPLATE = "platform/platformEmailTemplate/preview",
  SEND_PLATFORM_TEMPLATE_PREVIEW_EMAIL = "platform/platformEmailTemplate/sendPreviewEmail",
  UPDATE_PLATFORM_EMAIL_TEMPLATE_DETAILS = "platform/platformEmailTemplate/update",
  // Registration Email Template related Api
  REGISTRATION_EMAIL_TEMPLATE_LIST = "admin/registrationEmailTemplate/findByRegistrationId",
  GET_REGISTRATION_EMAIL_TEMPLATE_DETAIL = "admin/registrationEmailTemplate/findById",
  UPDATE_REGISTRATION_EMAIL_TEMPLATE_DETAILS = "admin/registrationEmailTemplate/update",
  PREVIEW_REGISTRATION_EMAIL_TEMPLATE = "admin/registrationEmailTemplate/preview",
  PREVIEW_REGISTRATION_EMAIL_CONFIG = "admin/emailConfig/preview",
  SEND_REGISTRATION_TEMPLATE_PREVIEW_EMAIL = "admin/registrationEmailTemplate/sendPreviewEmail",
  SYNC_REGISTRATION_TEMPLATES = "admin/registrationEmailTemplate/sync",
  // Platform Email Snippet related Api
  PLATFORM_EMAIL_SNIPPET_LIST = "platform/platformEmailSnippet/findAll",
  GET_PLATFORM_EMAIL_SNIPPET_DETAIL = "platform/platformEmailSnippet/findById",
  UPDATE_PLATFORM_EMAIL_SNIPPET_DETAILS = "platform/platformEmailSnippet/update",
  PREVIEW_PLATFORM_EMAIL_SNIPPET = "platform/platformEmailSnippet/preview",
  // Registration Email Snippet related Api
  REGISTRATION_EMAIL_SNIPPET_LIST = "admin/regLevelProgramEmailSnippet/findAll",
  GET_REGISTRATION_EMAIL_SNIPPET_DETAIL = "admin/regLevelProgramEmailSnippet/findById",
  // UPDATE_REGISTRATION_EMAIL_SNIPPET_DETAILS = "admin/regLevelProgramEmailSnippet/update",
  // PREVIEW_REGISTRATION_EMAIL_SNIPPET = "admin/regLevelProgramEmailSnippet/preview",
  SYNC_REGISTRATION_SNIPPETS = "admin/regLevelProgramEmailSnippet/sync",
  DELETE_DIVISION = "admin/division/delete",
  GET_MEETING_INVENTORY_LIST = "admin/meetingInventoryForm/findByRegistrationIdGroupedByEvent",
  GET_MEETING_INVENTORY_DETAIL = "admin/meetingInventoryForm/findById",
  GET_RATE_CARD_LIST_BY_INVENTORY_TYPE = "admin/rateCard/findByRegistrationIdAndInventoryTypes",
  GET_MEETING_INVENTORY_AVAILABLE_EVENTS_PROGRAMS_LIST = "admin/event/findAllByRegistrationIdForMeetingInventoryForm",
  CREATE_MEETING_INVENTORY_FORM = "admin/meetingInventoryForm/create",
  UPDATE_MEETING_INVENTORY_FORM = "admin/meetingInventoryForm/update",
  DELETE_MEETING_INVENTORY_FORM = "admin/meetingInventoryForm/{id}/delete",
  FIND_FORM_BY_INVENTORY_TYPE = "inventory/{type}/findForm",
  ADD_MEETING_INVENTORY = "admin/addInventory/meeting",
  PROGRAM_ORGANIZATION_LIST = "admin/programOrganization/findByProgramId",
  GET_PROGRAM_ORGANIZATION = "admin/programOrganization/fetchSchema",
  UPDATE_PROGRAM_ORGANIZATION = "admin/programOrganization/update",
  ADD_INVENTORY_BULK_TICKET = "admin/addBulkTicket",
  GET_EVENTS_WITH_PROGRAMS_BY_REGISTRATION_ID = "admin/event/findByRegistrationIdWithMeetingPrograms",
  GET_INVENTORY_CONFIG_BY_TYPE = "admin/inventoryConfiguration/findByRegistrationIdAndInventoryType",
  ADMIN_PURCHASE_ORDER_LIST = "admin/purchaseOrder/list",
  ADMIN_PURCHASE_ORDER_TRANSACTIONS = "admin/transaction/findByPurchaseOrderId",
  PURCHASE_ORDER_PROCESS = "admin/purchaseOrder/process",
  PURCHASE_ORDER_ADJUSTMENT = "admin/purchaseOrderAdjustment/adjust",
  PURCHASE_ORDER_SEND_EMAIL = "admin/purchaseOrder/sendPurchaseOrder",
  AMOUNT_TO_BE_REFUNDED = "admin/tax/calculate",
  INITIATE_OFFLINE_TRANSFER_PO = "admin/purchaseOrder/initiateOffline",
  APPROVE_OFFLINE_TRANSFER_PO = "admin/purchaseOrder/completeOfflineOrder",
  //registration dashboard
  GET_ADMIN_ACTION_BY_REGISTRATION_ID = "admin/registration/adminActions/count/findById",
  GET_REGISTRATION_COUNT_FOR_REG_FORM = "admin/registration/ticketForm/count/findById",
  GET_REVENUE_BY_REGISTRATION_ID = "admin/registration/revenue/findById",
  GET_EVENT_AND_PROGRAM_FOR_DASHBOARD = "admin/event/programs/timeline/findByRegistrationId",
  GET_PROGRAM_PROFILE_FORMS_LIST = "admin/profileForm/findByProgramId",
  REFRESH_TRANSACTIONS_IN_PURCHASE_ORDER = "admin/purchaseOrder/refreshTransaction",
  GET_INVENTORY_CONFIGURATION_LIST = "admin/inventoryConfiguration/findAllByRegistrationId",
  GET_INVENTORY_CONFIGURATION_DETAILS = "admin/inventoryConfiguration/findById",
  UPDATE_INVENTORY_CONFIGURATION_DETAILS = "admin/inventoryConfiguration/update",
  CREATE_PURCHASE_ORDER = "admin/purchaseOrder/create",
  CANCEL_PURCHASE_ORDER = "admin/purchaseOrder/cancel",
  CANCEL_TRANSACTION_REQUEST_TO_INVOICE_PAYER = "admin/invoicePaymentRequest/cancel",
  GET_TAX_CONFIGURATION_BY_ENTITY_AND_INVENTORY_TYPE = "admin/inventoryTaxConfiguration/findByContextEntityIdAndInventoryType",
  GET_PROGRAM_STAGES_LIST = "admin/programWorkFlowEmailTask/findByProgramId",
  GET_PROGRAM_STAGE_BASIC_DETAILS = "admin/program/timelineItem/findById",
  UPDATE_PROGRAM_STAGE_BASIC_DETAILS = "admin/program/timelineItem/update",
  GET_AGENDA_MEMBERS_LIST = "admin/agendaMember/profile/getByEventId",
  GET_AGENDA_MEMBER_PROFILE_BY_EVENT_PARTICIPANT_ID = "admin/agendaMember/profile/getByEventParticipantId",
  UPDATE_AGENDA_MEMBER_PROFILE_STATUS = "admin/agendaMember/profile/updateStatus",
  UPDATE_AGENDA_MEMBER_PROFILE = "admin/agendaMember/profile/update",
  CREATE_AGENDA_MEMBER_PROFILE = "admin/agendaMember/profile/create",
  ADD_EVENT_PARTICIPANT_TAG = "admin/eventParticipant/addTags",
  GET_PROGRAM_STAGES_EMAIL_SNIPPETS_LIST = "admin/programWorkFlowEmailTask/findByProgramTimeLineId",
  PREVIEW_PROGRAM_STAGES_EMAIL_SNIPPETS = "admin/programEmailSnippet/preview",
  UPDATE_OFFLINE_TRANSACTION = "admin/transaction/offline/update",
  //Tabletalk
  GET_TABLETALK_TOPIC_LIST_BY_PROGRAM_ID = "admin/tabletalkTopic/findByProgramId",
  GET_TABLETALK_TOPIC_DETAIL = "admin/tabletalkTopic/{id}",
  CREATE_TABLETALK_TOPIC = "admin/tabletalkTopic/create",
  UPDATE_TABLETALK_TOPIC = "admin/tabletalkTopic/update",
  DELETE_TABLETALK_TOPIC = "admin/tabletalkTopic/delete/{id}",
  GET_TIMESLOTS_BY_PROGRAM_ID = "admin/timeSlot/findByProgramId",
  //Admin Program Participant Profile
  GET_PROGRAM_PARTICIPANT_PROFILE_BY_PROGRAM_ID = "admin/programParticipant/profile/findByProgramId",
  GET_PROGRAM_PARTICIPANT_MEETING_PROFILE = "admin/programParticipant/{programParticipantId}/profile/meeting",
  GET_PROGRAM_PARTICIPANT_TABLETALK_PROFILE = "admin/programParticipant/{programParticipantId}/profile/tabletalk",
  UPDATE_PROGRAM_PARTICIPANT_TABLETALK_PROFILE = "admin/programParticipant/profile/tabletalk/initiateOrUpdate",
  UPDATE_PROGRAM_PARTICIPANT_MEETING_PROFILE = "admin/programParticipant/profile/meeting/initiateOrUpdate",
  UPDATE_PROGRAM_PARTICIPANT_MEETING_PROFILE_STATUS = "admin/programParticipant/profile/meeting/updateStatus",
  UPDATE_PROGRAM_PARTICIPANT_TABLETALK_PROFILE_STATUS = "admin/programParticipant/profile/tabletalk/updateStatus",
  GET_PROGRAM_PARTICIPANT_TIME_SESSION = "programParticipant/fetchTimeSessions",
  UPDATE_PROGRAM_PARTICIPANT_TIME_SESSION = "admin/programParticipant/update/timeSlot",
  // Meetup Profile Form Config APIs
  PROGRAM_PROFILE_FORMS_LIST = "admin/registrationForm/fetchProfileConfiguration",
  PROGRAM_PROFILE_FORM_CREATE = "admin/profileForm/create",
  PROGRAM_PROFILE_FORM_UPDATE = "admin/profileForm/update",
  PROGRAM_PROFILE_FORM_DELETE = "admin/profileForm/delete",
  PROGRAM_PROFILE_FORM_BY_ID = "admin/profileForm/findById",
  PROGRAM_PROFILE_GET_SCHEMA_FIELDS = "admin/schemaField/findByRegistrationIdForRegAndProfileForm",
  GET_REG_FORMS_BY_PARTICIPANT_TYPE_AND_SUB_ROLES = "admin/registrationForm/findByParticipantTypeAndSubRoles",
  GET_PROFILE_FORM_FIELDS_FOR_COPY = "admin/profileForm/findByIdForCopy",
  ORGANIZATION_PROFILE_GET_SCHEMA_FIELDS = "admin/schemaField/findByRegistrationIdForOrganizationProfileForm",
  ORGANIZATION_PROFILE_FORM_CREATE = "admin/organizationProfileForm/create",
  ORGANIZATION_PROFILE_FORM_UPDATE = "admin/organizationProfileForm/update",
  ORGANIZATION_PROFILE_FORM_GET = "admin/organizationProfileForm/findById",
  ORGANIZATION_PROFILE_FORM_DELETE = "admin/organizationProfileForm/{id}/delete",
  PRODUCT_PROFILE_GET_SCHEMA_FIELDS = "admin/productProfileForm/fetchConfiguration",
  PRODUCT_PROFILE_FORM_CREATE = "admin/productProfileForm/create",
  PRODUCT_PROFILE_FORM_UPDATE = "admin/productProfileForm/update",
  PRODUCT_PROFILE_FORM_GET = "admin/productProfileForm/findById",
  PRODUCT_PROFILE_FORM_DELETE = "admin/productProfileForm/delete/{id}",
  // program header
  GET_PROGRAM_SKIPPED_TIMELINE = "admin/program/skipped/timeline",
  CREATE_PROGRAM_TIMELINE_EMAIL_SNIPPET_TASK_GROUP = "admin/programWorkFlowEmailTask/create",
  UPDATE_PROGRAM_TIMELINE_EMAIL_SNIPPET_TIME_AND_FLAG = "admin/programEmailSnippet/flagAndTime/update",
  UPDATE_PROGRAM_TIMELINE_EMAIL_SNIPPET_GROUP_DATE = "admin/programWorkFlowEmailTask/updateScheduleDate",
  DELETE_PROGRAM_TIMELINE_EMAIL_SNIPPET_GROUP = "admin/programWorkFlowEmailActivity/delete",
  UPDATE_PROGRAM_TIMELINE_EMAIL_SNIPPET_CONTENT = "admin/programEmailSnippet/content/update",
  GET_CARDS_CONFIG_LIST = "admin/cardConfig/findByContextIdAndContextType",
  CREATE_CARDS_CONFIG = "admin/cardConfig/create",
  UPDATE_CARDS_CONFIG = "admin/cardConfig/update",
  GET_CARD_CONFIG_BY_ID = "admin/cardConfig/findById",
  DELETE_CARD_CONFIG = "admin/cardConfig/delete",
  GET_FIELDS_FOR_CARD_CONFIG = "admin/schemaField/cardConfig/findByRegistrationIdAndSelectableType",
  GET_FEATURED_LIST = "admin/featuredList/findByContextIdAndContextEntityTypeAndContextType",
  GET_SECONDARY_FIELDS_FOR_FSL = "admin/schemaField/featuredList/findByRegistrationIdAndSelectableType",
  GET_FSL_BY_ID = "admin/featuredList/findById",
  CREATE_FSL = "admin/featuredList/create",
  UPDATE_FSL = "admin/featuredList/update",
  FIELDS_LIST_FOR_SEARCH_CRITERIA_ACTOR = "admin/criteriaConfig/actor/findByRegistrationIdAndType",
  FIELDS_LIST_FOR_SEARCH_CRITERIA_SELECTABLE = "admin/criteriaConfig/selectable/findByRegistrationIdAndTypeAndSelectableType",
  AVAILABLE_TAGS_OR_SUB_ROLES_LIST_FOR_DEFAULT_FSL = "admin/featuredList/findAvailableTagsOrSubRoles",
  DELETE_FSL = "admin/featuredList/delete",
  GET_FIELDS_FOR_FIELD_MAPPING = "admin/schemaField/featuredList/findForFieldMapping",
  // program workflow
  GET_PROGRAM_FEEDBACK_LIST = "admin/programParticipant/findByProgramIdForMeetingFeedbackList",
  // reports
  GET_AVAILABLE_REPORTS_LIST = "admin/reportTemplate/findByRegistrationIdAndContextEntityId",
  GET_AVAILABLE_REPORTS_LIST_FOR_REGISTRATION = "admin/reportTemplate/findAllByRegistrationId",
  GENERATE_REPORT_BY_TEMPLATE_ID = "admin/report/generateByTemplateId/async",
  GET_REPORT_BY_TEMPLATE_ID_AND_PARTICIPANT_ID = "admin/report/generateByTemplateIdAndProgramParticipantId",
  DOWNLOAD_REPORT_BY_RESOURCE_ID = "resourceAsset/download/report/{id}",
  SEND_MEETING_SUMMARY_EMAIL = "admin/meeting/summary/sendEmail",
  GET_UTILITY_DATA_LIST_BY_REGISTRATION_AND_FEATURE = "admin/registrationUtilityData/getUtilityDataByRegistrationAndFeature",
  GET_UTILITY_DATA_MASTER_LIST_BY_REGISTRATION_AND_FEATURE = "admin/platformUtilityData/getConfiguredByFeatureAndRegistration",
  GET_UTILITY_DATA_DETAILS = "admin/registrationUtilityData/{id}",
  UPDATE_UTILITY_DATA_DETAILS = "admin/registrationUtilityData/update",
  PUBLISH_UTILITY_DATA_MODULE = "admin/registrationUtilityData/publish",
  DELETE_UTILITY_DATA_MODULE = "admin/registrationUtilityData/{id}",
  SYNC_UTILITY_DATA_FEATURE = "admin/registrationUtilityData/sync",
  CREATE_UTILITY_DATA_MODULES_FROM_PLATFORM_MODULES = "admin/registrationUtilityData/createByPlatformUtilityData",
  GET_SPONSOR_ORGANIZATION_LIST = "admin/sponsorOrganization/findByEventId",
  GET_EVENT_SPONSOR_ORGANIZATION_LIST = "admin/sponsorEventOrganization/findByEventId",
  GET_SPONSOR_ORGANIZATION_DETAILS = "admin/sponsorOrganization/{id}",
  CREATE_SPONSOR_ORGANIZATION_DETAILS = "admin/sponsorOrganization/create",
  UPDATE_SPONSOR_ORGANIZATION_DETAILS = "admin/sponsorOrganization/update",
  DELETE_SPONSOR_ORGANIZATION_DETAILS = "admin/sponsorOrganization/delete/{id}",
  GET_SPONSOR_LEVELS_LIST = "admin/sponsorshipLevel/findByEventId",
  GET_SPONSOR_LEVELS_DETAILS = "admin/sponsorshipLevel/{id}",
  DELETE_SPONSOR_LEVELS_DETAILS = "admin/sponsorshipLevel/delete/{id}",
  UPDATE_SPONSOR_LEVELS_DETAILS = "admin/sponsorshipLevel/update",
  CREATE_SPONSOR_LEVELS_DETAILS = "admin/sponsorshipLevel/create",
  FIND_EVENT_SPONSOR_ORGANIZATION = "admin/organization/findByNameForSponsorOrganization",
  REPORTS_SYNC_BY_REG_ID = "admin/report/populate",
  GET_REPORT_COLUMNS_LIST = "admin/reportTemplate/reportOutputMetadata",
  UPDATE_REPORT_COLUMNS_LIST = "admin/report/reportOutputMetadata/update",
  RESET_REPORT_COLUMNS_META = "admin/report/reset",
  // Feedback configuration
  GET_FEEDBACK_FORMS_BY_EVENT_ID = "admin/feedbackForm/findByEventId",
  GET_FEEDBACK_CONFIGURATION_DETAILS = "admin/feedbackForm/fetchConfiguration",
  GET_FEEDBACK_FIELDS_MASTER_LIST = "admin/schemaField/findByRegistrationIdForFeedbackForm",
  CREATE_FEEDBACK_FORM = "admin/feedbackForm/create",
  GET_FEEDBACK_FORM_DETAILS = "admin/feedbackForm/findById",
  UPDATE_FEEDBACK_FORM = "admin/feedbackForm/update",
  DELETE_FEEDBACK_FORM = "admin/feedbackForm/delete",
  CREATE_FEEDBACK_FORM_HOLDER = "admin/feedbackFormHolder/create",
  UPDATE_FEEDBACK_FORM_HOLDER = "admin/feedbackFormHolder/update",
  // Event Sectors and Locations APIs
  EVENT_SECTOR_LIST = "admin/eventSector/findByEventId",
  EVENT_SECTOR_CREATE = "admin/eventSector/create",
  EVENT_SECTOR_UPDATE = "admin/eventSector/update",
  EVENT_SECTOR_DETAILS = "admin/eventSector/{id}",
  EVENT_SECTOR_DELETE = "admin/eventSector/{id}",
  EVENT_LOCATION_LIST = "admin/eventLocation/findByEventId",
  EVENT_LOCATION_CREATE = "admin/eventLocation/create",
  EVENT_LOCATION_UPDATE = "admin/eventLocation/update",
  EVENT_LOCATION_DETAILS = "admin/eventLocation/{id}",
  EVENT_LOCATION_DELETE = "admin/eventLocation/{id}",
  // Program Enrollment APIs
  GET_PARTICIPANTS_FOR_PROGRAM = "admin/programParticipant/enrollment/findByProgramId",
  GET_PARTICIPANT_ENROLLMENT_DETAILS = "admin/programParticipant/findByRegistrationParticipantIdAndProgramId",
  UPDATE_PROGRAM_ENROLLMENT_PARTICIPATION_DETAILS = "admin/programParticipant/initialize",
  ADD_TAG_TO_PROGRAM_PARTICIPANT = "admin/programParticipant/tag/add",
  REMOVE_TAG_FROM_PROGRAM_PARTICIPANT = "admin/programParticipant/tag/remove",
  ENROLL_PARTICIPANT_IN_PROGRAM = "admin/programParticipant/create",
  REMOVE_PROGRAM_PARTICIPANT_FROM_PROGRAM = "admin/programParticipant/remove",
  GET_LATEST_UI_VERSION_FOR_PROGRAM_PARTICIPANT = "admin/programParticipant/workflow/getIdAndUiVersion",
  GET_APPLICABLE_TAGS_FOR_PROGRAM = "programParticipant/workflow/getListingConfig",
  GET_SELECTABLE_LIST_IN_SELECTION = "admin/selection/findSelectableList",
  GET_SELECTIONS_FOR_SENDER = "admin/selection/findSelectionsBySender",
  UPDATE_SELECTION_FOR_PARTICIPANT = "admin/selection/update",
  MEETING_REP_ACK_EMAIL_RESEND = "programParticipant/meetingRepAck/sendEmail",
  // Agenda - Time Sessions
  GET_TIME_SESSIONS_BY_EVENT = "admin/timeSession/findByEventId",
  GET_TIME_SESSION_DETAILS = "admin/timeSession/{id}",
  CREATE_TIME_SESSION = "admin/timeSession/create",
  UPDATE_TIME_SESSION = "admin/timeSession/update",
  DELETE_TIME_SESSION = "admin/timeSession/delete/{id}",
  // Agenda - Time Slots
  GET_TIME_SLOTS_BY_TIME_SESSION_AND_PROGRAM = "admin/timeSlot/findByProgramIdAndTimeSessionId",
  CREATE_OR_UPDATE_TIME_SLOTS = "admin/timeSlot/upsert",
  DELETE_TIME_SLOT = "admin/timeSlot/delete/{id}",
  // Agenda - Participation roles
  GET_PARTICIPATION_ROLES_BY_EVENT = "admin/eventParticipantRole/findByEventId",
  CREATE_PARTICIPATION_ROLE = "admin/eventParticipantRole/create",
  UPDATE_PARTICIPATION_ROLE = "admin/eventParticipantRole/update",
  DELETE_PARTICIPATION_ROLE = "admin/eventParticipantRole/delete/{id}",
  // Agenda - Locations
  GET_EVENT_AGENDA_LOCATIONS_BY_EVENT = "admin/eventAgendaLocation/findByEventId",
  CREATE_EVENT_AGENDA_LOCATION = "admin/eventAgendaLocation/create",
  UPDATE_EVENT_AGENDA_LOCATION = "admin/eventAgendaLocation/update",
  DELETE_EVENT_AGENDA_LOCATION = "admin/eventAgendaLocation/delete/{id}",
  // Agenda - General Attributes (Meta)
  GET_GENERAL_ATTRIBUTES_BY_EVENT = "admin/eventAgendaMeta/findByEventId",
  GET_GENERAL_ATTRIBUTE_DETAILS = "admin/eventAgendaMeta/{id}",
  CREATE_GENERAL_ATTRIBUTE = "admin/eventAgendaMeta/create",
  UPDATE_GENERAL_ATTRIBUTE = "admin/eventAgendaMeta/update",
  DELETE_GENERAL_ATTRIBUTE = "admin/eventAgendaMeta/delete/{id}",
  // Agenda - Items
  GET_AGENDA_ITEM_DETAILS = "admin/eventAgenda/{id}",
  CREATE_AGENDA_ITEM = "admin/eventAgenda/create",
  UPDATE_AGENDA_ITEM = "admin/eventAgenda/update",
  DELETE_AGENDA_ITEM = "admin/eventAgenda/delete/{id}",
  UPDATE_AGENDA_ITEM_STATUS = "admin/eventAgenda/status/update",
  UPDATE_ALL_AGENDA_ITEMS_STATUS = "admin/eventAgenda/status/updateAll",
  //Tabletalk Meeting List
  GET_TABLETALK_MEETING_LIST_BY_PROGRAM_ID = "admin/tabletalk/findByProgramId",
  GET_TABLETALK_MEETING_DETAIL_BY_ID = "admin/tabletalk/findDetailsById",
  UPDATE_TABLETALK_MEETING = "admin/tabletalk/update",
  GET_ALTERNATE_TABLETALK_MEETINGS = "admin/tabletalk/getAlternateMeetings",
  MOVE_PARTICIPANT_IN_TABLETALK_MEETING = "admin/tabletalk/moveParticipant",
  GET_AVAILABLE_TABLETALK_MODERATOR = "admin/tabletalk/findAvailableModerators",
  UPDATE_TABLETALK_MEETING_STATUS = "admin/tabletalkMeeting/updateStatus",
  PARTICIPANTS_FOR_MEETINGS = "admin/meeting/search",
  UPDATE_MEETING_NOTE = "admin/meeting/note/update",
  CANCEL_MEETING = "admin/meeting/cancel",
  SEND_CALENDAR_INVITE = "admin/tabletalk/sendCalendarInvite",
  TABLETAlK_PARTICIPANT_SEARCH_FOR_MANUAL_ADD = "admin/tabletalk/findParticipantsForManualAddition",
  //TABLETAlK INVITATION
  GET_TABLETALK_INVITATION_LIST = "admin/programParticipant/findByProgramIdForTabletalkInvitationList",
  FIND_TIME_SESSIONS_AND_SLOTS = "admin/findTimeSessionAndTimeSlots",
  FIND_PARTICIPANT_IN_PROGRAM = "admin/programParticipant/searchByName",
  SEND_MEEETING_INVITE = "admin/meeting/sendCalendarInvite",
  // Reimbursement
  FIND_REIMBURSEMENT_FOR_PROGRAM = "admin/participant/reimbursement/listByProgramId",
  UPDATE_REIMBURESEMENT_STATUS_FOR_PARTICIPANT = "admin/participant/reimbursement/updateStatus",
  GET_REIMBURSEMENT_DETAILS_OF_PARTICIPANT = "admin/participant/reimbursement/findById",
  UPDATE_REIMBURSEMENT_AMOUNT_OR_NOTE = "admin/participant/reimbursement/update",
  // Badge sync
  SYNC_BADGE_DETAILS = "admin/badge/syncForRegistrationParticipant",
  MARK_AS_SHOW_OR_NO_SHOW = "admin/meeting/markNotAttended",
  ORGANIZATION_SEARCH_IN_MEETING_LISTING = "admin/organization/findAllByName",
  CREATE_ASSOCIATED_PROGRAM = "admin/program/associatedProgram/create",
  UPDATE_ASSOCIATED_PROGRAM = "admin/program/associatedProgram/update",
  UPDATE_CONNECTION_PROGRAM = "admin/program/connectionsProgram/update",
  ANONYMISE_REGISTRATION_PARTICIPANT = "admin/registration/participant/anonymize",
  // Associated Program
  ASSOCIATED_PROGRAM_ACTIVITY_CREATE = "admin/associatedProgramActivity/create",
  ASSOCIATED_PROGRAM_ACTIVITY_UPDATE = "admin/associatedProgramActivity/update",
  ASSOCIATED_PROGRAM_ACTIVITY_GET_BY_ID = "admin/associatedProgramActivity/{id}",
  ASSOCIATED_PROGRAM_ACTIVITY_LIST_BY_PROGRAM_ID = "admin/associatedProgramActivity/findByProgramId",
  ASSOCIATED_PROGRAM_ACTIVITY_GET_PARENT_BY_PROGRAM_ID_AND_TYPE = "admin/associatedProgramActivity/findByProgramIdAndType",
  ASSOCIATED_PROGRAM_TIMESLOT_CREATE = "admin/timeSlot/associatedProgram/create",
  ASSOCIATED_PROGRAM_TIMESLOT_UPDATE = "admin/timeSlot/associatedProgram/update",
  ASSOCIATED_PROGRAM_TIMESLOT_LIST_BY_PROGRAM_ID = "admin/timeSlot/findActivityTimeSlotsByProgramId",
  ASSOCIATED_PROGRAM_TIMESLOT_DELETE = "admin/timeSlot/delete/{id}",
  ASSOCIATED_PROGRAM_TIMESLOT_ASSOCIATION_CREATE = "admin/associatedProgramActivity/activityTimeSlot/create",
  ASSOCIATED_PROGRAM_TIMESLOT_ASSOCIATION_UPDATE = "admin/associatedProgramActivity/activityTimeSlot/update",
  ASSOCIATED_PROGRAM_TIMESLOT_ASSOCIATION_DELETE = "admin/associatedProgramActivity/activityTimeSlot/delete",
  ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_CREATE = "admin/associatedProgramActivity/activityAdmin/create",
  ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_DELETE = "admin/associatedProgramActivity/activityAdmin/delete",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPANTS_SEARCH_BY_NAME = "admin/eventParticipant/searchByName",
  ASSOCIATED_PROGRAM_ACTIVITY_UPDATE_STATUS = "admin/associatedProgramActivity/updateStatus",
  ASSOCIATED_PROGRAM_ACTIVITY_FIND_PARTICIPANTS = "eventParticipant/handPicking/findByEventId",
  ASSOCIATED_PROGRAM_ACTIVITY_HANDPICK_PARTICIPANT = "admin/activitySelection/handpick/create",
  ASSOCIATED_PROGRAM_ACTIVITY_REMOVE_HANDPICKED_PARTICIPANT = "admin/activitySelection/handpick/delete/{id}",
  ASSOCIATED_PROGRAM_ACTIVITY_FIND_ACTIVITY_FOR_SHORTLIST = "admin/activitySelection/findByActivity",
  ASSOCIATED_PROGRAM_ACTIVITY_SHORTLIST_PARTICIPANT = "admin/activitySelection/shortlist",
  ASSOCIATED_PROGRAM_ACTIVITY_CANCEL_ACTIVITY = "admin/associatedProgramActivity/cancel",
  ASSOCIATED_PROGRAM_ACTIVITY_LIST_FOR_WORKFLOW = "admin/associatedProgramActivity/findForWorkflowByProgramId",
  ASSOCIATED_PROGRAM_GET_ACTIVITY_AGENDAS = "admin/activity/findByProgramId",
  ASSOCIATED_PROGRAM_ACTIVITY_AGENDA_STATUS_CHANGE = "admin/activity/updateStatus",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPATION_LIST = "admin/activity/getParticipation",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPATION_UPDATE = "admin/activity/updateParticipation",
  ASSOCIATED_PROGRAM_AGEND_LIST_FOR_MARK_ATTENDANCE = "admin/activity/findByProgramIdForReconciliation",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPATION_MARK_ATTENDANCE = "admin/activity/markAttendance",
  ASSOCIATED_PROGRAM_PARTICIPATION_LIST_TO_MARK_ATTENDANCE = "admin/activity/getParticipationForReconciliation",

  ASSOCIATED_PROGRAM_ACTIVITY_ELIGIBLE_PARTICIPANT_COUNT = "admin/eventParticipant/findEligibleParticipantCountForCustomActivity",

  //Organization Profile
  ORGANIZATION_PROFILE_GET = "admin/programOrganization/{programOrganizationId}/profile/meeting",
  ORGANIZATION_PROFILE_UPDATE = "admin/programOrganization/update",
  PRODUCT_LIST_GET = "admin/product/findByProgramOrganizationId",
  PRODUCT_CREATE = "admin/product/create",
  PRODUCT_UPDATE = "admin/product/update",
  PRODUCT_DELETE = "product/delete",
  EVENT_LOCATION_LIST_BY_CONTEXT_TYPE = "admin/eventLocation/findByEventIdAndContextTypeAndEntityId",
  // Event Timelines
  EVENT_STAGE_GET_BY_ID = "admin/event/timelineItem/findById",
  EVENT_STAGE_UPDATE_BY_ID = "admin/event/timelineItem/update",
  EVENT_STAGE_EMAIL_SNIPPETS_PREVIEW = "admin/eventEmailSnippet/preview",
  EVENT_STAGE_LIST_BY_EVENT_ID = "admin/eventEmailWorkflow/findByEventId",
  EVENT_STAGE_UPDATE_END_DATE = "admin/event/timelineItem/endDate/update",
  EVENT_TIMELINE_EMAIL_SNIPPET_DELETE_GROUP = "admin/eventEmailSnippetGroup/delete",
  EVENT_TIMELINE_EMAIL_SNIPPET_CREATE_TASK_GROUP = "admin/eventEmailSnippetGroup/create",
  EVENT_TIMELINE_EMAIL_SNIPPET_UPDATE_CONTENT = "admin/eventEmailSnippet/content/update",
  EVENT_STAGES_EMAIL_SNIPPETS_LIST = "admin/eventEmailSnippetGroup/findByEventTimelineItemId",
  EVENT_TIMELINE_EMAIL_SNIPPET_UPDATE_TIME_AND_FLAG = "admin/eventEmailSnippet/flagAndTime/update",
  EVENT_TIMELINE_EMAIL_SNIPPET_UPDATE_GROUP_DATE = "admin/eventEmailSnippetGroup/updateScheduleDate",
  // Exhibitor
  PROGRAM_ORGANIZATION_GET_ALL = "admin/programOrganization/findAllByProgramId",
  PROGRAM_ORGANIZATION_MARK_EXHIBITOR = "admin/programOrganization/markExhibitor",
  PROGRAM_ORGANIZATION_UN_INITIALIZE_MEETING_CAP = "admin/programOrganization/unInitializeMeetingCap",
  STATIC_DATA_COMMUNICATION_FIELDS = "admin/staticData/communicationDto/getFields",
  REG_EMAIL_TEMPLATES_FORCE_SYNC = "admin/registrationEmailTemplate/forceSync",
  // REG_EMAIL_SNIPPET_FORCE_SYNC = "admin/registrationEmailSnippet/forceSync",
  PROGRAM_EMAIL_SNIPPET_FORCE_SYNC = "admin/programEmailSnippet/forceSync",
  EVENT_EMAIL_SNIPPET_FORCE_SYNC = "admin/eventEmailSnippet/forceSync",
  //vendor
  VENDOR_GET_ALL_BY_EVENT_ID = "vendorConfiguration/findByEventId",
  VENDOR_CONFIGURATION_GET = "vendorConfiguration/{id}",
  VENDOR_CONFIGURATION_CREATE = "vendorConfiguration/create",
  VENDOR_CONFIGURATION_UPDATE = "vendorConfiguration/update",
  VENDOR_CONFIGURATION_VALIDATE = "vendor/configuration/validate",
  REGISTRATION_ORGANIZATION_LIST_PAGINATED = "admin/registrationOrganization/search",

  REGISTRATION_PARTICIPANT_LIST_PAGINATED = "admin/registrationParticipant/search",
  REGISTRATION_PARTICIPANT_LIST_PAGINATED_COUNT = "admin/registrationParticipant/count",
  REGISTRATION_PARTICIPANT_SEARCH_BY_NAME = "admin/registrationParticipant/searchByName",

  EVENT_SERIES_ORGANIZATION_SEARCH_BY_NAME = "admin/organization/findAllByName",
  REGISTRATION_ORGANIZATION_SEARCH_BY_NAME = "admin/registrationOrganization/findAllByName",
  VENDOR_ENTITY_GET = "vendorConfiguration/entity/{id}",
  VENDOR_ENTITY_CREATE = "vendorConfiguration/entity/create",
  VENDOR_ENTITY_UPDATE = "vendorConfiguration/entity/update",
  VENDOR_MAPPING_FIELDS_GET = "vendorConfiguration/externalFieldMapping/fields",
  VENDOR_CONFIGURATION_ENABLE = "vendorConfiguration/{id}/enable",
  VENDOR_CONFIGURATION_DISABLE = "vendorConfiguration/{id}/disable",
  VENDOR_EXTERNAL_FIELDS_BULK_CREATE_UPDATE = "vendorConfiguration/externalField/createOrUpdate",
  VENDOR_EXTERNAL_FIELD_CREATE = "vendorConfiguration/externalField/create",
  VENDOR_EXTERNAL_FIELD_UPDATE = "vendorConfiguration/externalField/update",
  VENDOR_EXTERNAL_FIELD_DELETE = "vendorConfiguration/externalField",
  VENDOR_EXTERNAL_FIELD_MAPPINGS_GET = "vendorConfiguration/externalFieldMapping/findByVendorEntityConfiguration",
  VENDOR_EXTERNAL_FIELD_MAPPINGS_SAVE = "vendorConfiguration/externalFieldMapping/createOrUpdate",
  VENDOR_ENTITY_CONFIGURATION_ENABLE = "vendorConfiguration/entity/{id}/enable",
  VENDOR_ENTITY_CONFIGURATION_DISABLE = "vendorConfiguration/entity/{id}/disable",
  VENDOR_ENTITY_SYNC_STATS_GET = "vendorConfiguration/entity/syncStatistics",
  VENDOR_ENTITY_TRIGGER_BULK_PUSH = "admin/vendorEntityConfiguration/bulkPush",
  ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_INVITE_PARTICIPANT = "admin/activity/inviteParticipation",

  GET_PROGRAM_ORGANIZATION_BY_ID = "admin/programOrganization/{programOrganizationId}",

  GET_SPONSORSHIP_META_DETA = "admin/program/findSponsoredFieldsAndKeywords",

  GET_SPONSORED_KEYWORDS_AND_FIELDS_FOR_PROGRAM_ORGANIZATION = "admin/programOrganization/sponsoredKeywordAndFieldOptions",
  ADD_KEYWORD_TO_PROGRAM_ORGANIZATION = "admin/programOrganization/sponsoredKeyword",

  REMOVE_SPONSORED_KEYWORD_FROM_PROGRAM_ORGANIZATION = "admin/programOrganization/sponsoredKeyword",

  ADD_SPONSORED_FIELD_OPTION = "admin/programOrganization/sponsoredFieldOption",

  REMOVE_SPONSORED_FIELD_OPTION = "admin/programOrganization/sponsoredFieldOption",
  // SMS
  SMS_CONFIG_GET = "admin/textNotificationConfig/findByEntityId",
  SMS_CONFIG_CREATE = "admin/textNotificationConfig/create",
  SMS_CONFIG_UPDATE = "admin/textNotificationConfig/update",
  SMS_TEMPLATES_LIST_GET = "admin/registrationTextNotificationTemplate/findByRegistrationId",
  SMS_TEMPLATE_SYNC = "admin/registrationTextNotificationTemplate/sync",
  SMS_DETAILS_GET = "admin/registrationTextNotificationTemplate/findById",
  SMS_TEMPLATE_PREVIEW = "admin/registrationTextNotificationTemplate/preview",
  SMS_TEMPLATE_UPDATE = "admin/registrationTextNotificationTemplate/update",
  SMS_HISTORY_LIST = "admin/adminTextNotificationTemplate/findByRegistrationId",
  SMS_SEND_NOW = "admin/adminTextNotificationTemplate/send",
  GET_SUMMARY_FOR_ACTIVITY = "admin/activity/getSummary",
  GET_EMAIL_DOMAIN_LIST = "evaluationCriteria/findByRegistrationId",
  GET_EMAIL_DOMAIN_LIST_DETAILS = "evaluationCriteria/{id}",
  CREATE_EMAIL_DOMAIN_LIST = "evaluationCriteria/create",
  UPDATE_EMAIL_DOMAIN_LIST = "evaluationCriteria/update",
  DELETE_EMAIL_DOMAIN_LIST = "evaluationCriteria/delete/{id}",
  CREATE_BULK_UPLOAD_EMAIL_DOMAIN_LIST = "admin/evaluationCriteria/emailDomain/bulkUpload/create",
  UPDATE_BULK_UPLOAD_EMAIL_DOMAIN_LIST = "admin/evaluationCriteria/emailDomain/bulkUpload/update",
  BULK_DOWNLOAD_EMAIL_DOMAIN_LIST = "admin/evaluationCriteria/emailDomain/downloadCsvTemplate",
  RATE_CARD_BULK_UPLOAD_COUPON_CODE = "admin/rateCardDiscount/bulkUpload",
  RATE_CARD_BULK_DOWNLOAD_COUPON_CODE = "admin/rateCardDiscount/downloadCsvTemplate",

  CREATE_CONTACT_CONTEXT = "admin/contactContext/create",
  UPDATE_CONTACT_CONTEXT = "admin/contactContext/update",
  GET_CONTACT_CONTEXT_LIST_BY_CONTACT_MODE = "admin/contactContext/findAllByContactMode",

  GET_CONTACT_CONTEXT_BY_ID = "admin/contactContext/findById/{contactContextId}",

  GET_CRITERIA_FIELDS_FOR_CONTACT_CONTEXT_ACCESS_CONTROL = "admin/contactContext/access/criteriaFields",
  GET_CRITERIA_FIELDS_FOR_CONTACT_CONTEXT_LICENSEES = "admin/contactContext/licensee/criteriaFields",

  GET_EVENT_PARTICIPANTS_BY_NAME_OR_ORG_NAME = "admin/eventParticipant/searchByNameAndOrganizationName",

  UPDATE_CONTEXT_STATUS = "admin/contactContext/enabledFlag/update",
  SEARCH_MATCHING_INVOICES = "admin/purchaseOrder/search/v2",
  //scheduled jobs
  SCHEDULED_TRANSACTION_LOG_GET = "admin/queueTransactionLog",
  SCHEDULED_PROCESS_RETRY = "admin/queueTransactionLog/retryByProcessId",
  SCHEDULED_TRANSACTION_RETRY = "admin/queueTransactionLog/retryById",

  GET_EVENT_ORGANIZATION_BY_EVENT_ID = "admin/eventOrganization/search",
  GET_EVENT_ORGANIZATION_BY_ID = "admin/eventOrganization/findById",
  UPDATE_EVENT_ORGANIZATION = "admin/eventOrganization/update",
  GET_EXHIBITOR_PROFILE_BY_ID = "admin/eventOrganization/exhibitor/findById",
  UPDATE_EXHIBITOR_PROFILE = "admin/eventOrganization/exhibitor/update",
  UPDATE_EXHIBITOR_PROFILE_STATUS = "admin/eventOrganization/exhibitor/updateStatus",
  GET_OPTION_FOR_FIELD = "option/findForFieldRenderSubType",
  // exhibitor profile form
  EXHIBITOR_FORMS_LIST_GET = "admin/eventOrganizationProfileForm/fetchProfileConfiguration",
  EXHIBITOR_PROFILE_FORM_GET = "admin/eventOrganizationProfileForm/findById",
  EXHIBITOR_PROFILE_FORM_CREATE = "admin/eventOrganizationProfileForm/create",
  EXHIBITOR_PROFILE_FORM_UPDATE = "admin/eventOrganizationProfileForm/update",
  EXHIBITOR_PROFILE_FORM_DELETE = "admin/eventOrganizationProfileForm/{id}/delete",
  // Inventory
  INVENTORY_CONFIG_GET_LIST = "admin/inventory/list",
  INVENTORY_CONFIG_GET_DETAILS = "admin/inventory/findById",
  INVENTORY_CONFIG_CREATE = "admin/inventory/create",
  INVENTORY_CONFIG_UPDATE = "admin/inventory/update",
  INVENTORY_CONFIG_DELETE = "admin/inventory/delete",
  INVENTORY_LIST_FOR_ASSIGNMENT = "admin/inventory/findApplicableInventoryForParticipant",
  INVENTORY_PURCHASE_BY_ADMIN = "admin/addInventory",
  REGISTRATION_PARTICIPANT_ACCESS_PRIVILEGES_LIST = "admin/participant/accessPrivileges/{registrationParticipant}",
  PURCHASE_ORDER_DOWNLOAD = "admin/purchaseOrder/downloadPdf",
  BATCH_TASK_DELETE = "admin/batchTask/delete",
  REGISTRATION_PARTICIPANT_SYNC_TO_INTEGRATION = "admin/registrationParticipant/syncToIntegrations",
  REGISTRATION_PARTICIPANT_BADGE_EMAIL_SEND = "admin/registrationParticipant/sendBadgeEmail",
  TICKET_UPGRADE_FORMS_LIST = "admin/registrationFormUpgradeMapping/registrationFormList",
  //PDF template
  PLATFORM_PDF_TEMPLATE_GET_ALL = "platform/platformPdfTemplate/findAll",
  PLATFORM_PDF_TEMPLATE_GET_BY_ID = "platform/platformPdfTemplate/findById",
  PLATFORM_PDF_TEMPLATE_UPDATE = "platform/platformPdfTemplate/update",
  PLATFORM_PDF_TEMPLATE_PREVIEW = "platform/platformPdfTemplate/preview",
  PLATFORM_PDF_TEMPLATE_DOWNLOAD_PREVIEW = "platform/platformPdfTemplate/downloadPreview",
  REGISTRATION_PDF_TEMPLATE_GET_ALL = "platform/registrationPdfTemplate/findByRegistrationId",
  REGISTRATION_PDF_TEMPLATE_GET_BY_ID = "platform/registrationPdfTemplate/findById",
  REGISTRATION_PDF_TEMPLATE_UPDATE = "platform/registrationPdfTemplate/update",
  REGISTRATION_PDF_TEMPLATE_PREVIEW = "platform/registrationPdfTemplate/preview",
  REGISTRATION_PDF_TEMPLATE_DOWNLOAD_PREVIEW = "platform/registrationPdfTemplate/downloadPreview",
  REGISTRATION_PDF_TEMPLATE_SYNC = "platform/registrationPdfTemplate/sync",
  REGISTRATION_PDF_TEMPLATE_FORCE_SYNC = "platform/registrationPdfTemplate/forceSync",
  REGISTRATION_PDF_TEMPLATE_STATUS_UPDATE = "platform/registrationPdfTemplate/updateStatus",
  REGISTRATION_PDF_TEMPLATE_UPDATE_META = "platform/registrationPdfTemplate/updateMeta",
  STATIC_DATA_GET_PDF_FIELDS = "admin/staticData/pdfCommunicationDto/getFields",
  REGISTRATION_GET_ENABLED_FEATURE = "admin/registration/getEnabledFeatures",
  BULK_TICKET_ADMIN_LIST = "admin/registrationParticipant/getOrganizationBulkTicketAdmins",
  GET_INVENTORY_TYPE_FORMS = "inventory/{type}/findForm",
  BULK_TICKET_DETAIL_FOR_BTA = "bulkTicket/{registrationParticipantId}",
  GET_BULK_TICKET_ADMINS_BY_REGISTRATION_ID = "admin/registrationParticipant/getBulkTicketAdmins",
  GET_DIGITAL_SPACE_LIST = "admin/digitalSpaces/findByRegistration",
  CREATE_DIGITAL_SPACE = "admin/digitalSpaces/create",
  UPDATE_DIGITAL_SPACE = "admin/digitalSpaces/update",
  GET_DIGITAL_SPACE_BY_ID = "admin/digitalSpaces/findById",
  UPDATE_DIGITAL_SPACE_STATUS = "admin/digitalSpaces/markActive",
  FIND_EVENT_ORGANIZATIONS_WITH_UNASSIGNED_ORG_ADMIN = "admin/eventOrganization/exhibitor/findForUnassignedOrgAdmin",
  UPLOAD_ORG_CSV = "admin/organization/uploadCsv",
  UPLOAD_EVENT_ORG_CSV = "admin/eventOrganization/uploadCsv",
  DOWNLOAD_ORG_CSV_TEMPLATE = "admin/organization/downloadCsvTemplate",
  DOWNLOAD_EVENT_ORG_CSV_TEMPLATE = "admin/eventOrganization/downloadCsvTemplate",
  DOWNLOAD_REPORT_BY_CONTACT_CONTEXT = "admin/report/generateByReportType",
  GET_REGISTRATION_FIELDS_FOR_CONFIG = "admin/schemaField/findByRegistrationIdForAssociatedProgram",
  GET_CONFIGURED_FIELDS_FOR_COLUMN = "admin/program/associatedProgram/prioritizationFields",
  ACTIVITY_PARTICIPANT_PROFILE_VIEW = "admin/profile/meeting/getProfileForDisplayByParticipantId",
  SEND_EMAIL_INTRO = "admin/meeting/emailIntroduction/create",
  AI_TEXT_ENHANCEMENT = "aiAssist/textEnhancement",
  GET_PLATFORM_CRITERIA_OUT_REACH_LIST = "admin/platformQuery/outreach",
  GET_CRITERIA_CONFIG_FOR_OUTREACH = "admin/platformQuery/criteriaConfig",
  GET_CRITERIA_FOR_OUTREACH_BY_ID = "admin/platformQuery/{id}",
  CREATE_CRITERIA_FOR_OUTREACH = "admin/platformQuery/create",
  UPDATE_CRITERIA_FOR_OUTREACH = "admin/platformQuery/update",
  CREATE_PLATFORM_CRITERIA_EMAIL_TEMPLATE = "admin/platformQueryEmail/create",
  UPDATE_PLATFORM_CRITERIA_EMAIL_TEMPLATE = "admin/platformQueryEmail/update",
  GET_PLATFORM_CRITERIA_EMAIL_TEMPLATE = "admin/platformQueryEmail/findById",
  UPDATE_REGISTRATION_CRITERIA_EMAIL_TEMPLATE = "admin/regOutReachCriteriaQueryEmail/update",
  PREVIEW_PLATFORM_OUTREACH_EMAIL_TEMPLATE = "admin/platformQueryEmail/preview",
  SEND_PLATFORM_PREVIEW_EMAIL_OUTREACH = "admin/platformQueryEmail/sendPreviewEmail",
  CREATE_REGISTRATION_CRITERIA_EMAIL_TEMPLATE = "admin/regOutReachCriteriaQueryEmail/create",
  SEND_REGISTRATION_PREVIEW_EMAIL_OUTREACH = "admin/regOutReachCriteriaQueryEmail/sendPreviewEmail",
  GET_REGISTRATION_CRITERIA_EMAIL_TEMPLATE_BY_PLATFORM_QUERY_ID = "admin/regOutReachCriteriaQueryEmail/byPlatformQueryEmailId",
  GET_REGISTRATION_CRITERIA_EMAIL_TEMPLATE = "admin/regOutReachCriteriaQueryEmail/findById",
  PREVIEW_REGISTRATION_OUTREACH_EMAIL_TEMPLATE = "admin/regOutReachCriteriaQueryEmail/preview",
  GET_OUTREACH_QUERY_TEMPLATES_LIST_BY_REGISTRATION = "admin/regOutReachCriteriaQuery/outreach",
  GENERATE_OUTREACH_QUERY_TEMPLATE_REPORT = "admin/regOutReachCriteriaQuery/generateReport/async",
  GET_AVAILABLE_PROPERTIES_FOR_PLATFORM_OUTREACH_EMAIL_TEMPLATES = "admin/platformQueryEmail/getAvailableFreemarkerProperty",
  UNSCHEDULE_REGISTRATION_CRITERIA_EMAIL_TEMPLATE = "admin/regOutReachCriteriaQueryEmail/unSchedule"
}

export default ConsoleApi;
